/* eslint-disable */

export default {
  // order: 'order',
  shufflePlay: 'shufflePlay',
  orderLoop: 'orderLoop',
  // singleLoop: 'singleLoop',
}
